import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { redirectUri } from '../auth/oauth';
import {
  getAndClearOAuthState,
  getAndClearPkceVerifier,
  getAndClearRedirectPath,
} from '../auth/pkce';
import { exchangeCode } from '../auth/tokens';

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function handle() {
      const errorParam = searchParams.get('error');
      if (errorParam) {
        setError(
          `${errorParam}: ${searchParams.get('error_description') ?? 'Unknown OAuth error'}`
        );
        return;
      }
      const code = searchParams.get('code');
      if (!code) {
        setError('No authorization code received');
        return;
      }
      const storedState = getAndClearOAuthState();
      if (!storedState || searchParams.get('state') !== storedState) {
        setError('Invalid OAuth state - please try logging in again');
        return;
      }
      const verifier = getAndClearPkceVerifier();
      if (!verifier) {
        setError('Missing PKCE verifier - please try logging in again');
        return;
      }
      try {
        await exchangeCode(code, verifier, redirectUri());
        navigate(getAndClearRedirectPath() || '/', { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to complete login');
      }
    }
    void handle();
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="page">
        <p className="status error">Authentication error: {error}</p>
        <button type="button" onClick={() => navigate('/', { replace: true })}>
          Try again
        </button>
      </div>
    );
  }
  return <p className="status">Completing login…</p>;
}
